import { showNotificationMessage } from "./modules/uiState";

// Middleware: generic notifications for all rejected thunks with structured payloads
export const rejectionNotificationMiddleware =
  (storeAPI) => (next) => (action) => {
    // Only react to RTK rejections
    if (typeof action.type === "string" && action.type.endsWith("/rejected")) {
      const { payload, error } = action;

      // Only handle if the thunk used rejectWithValue (i.e., has a payload)
      if (payload) {
        // Best-effort extraction of message id and fallback message
        const messageId =
          payload.messageId ||
          (payload.code ? `ErrorMessage.${payload.code}` : undefined);
        const fallbackMessage =
          payload.message || error?.message || "Unexpected error";
        const values = payload.values;

        storeAPI.dispatch(
          showNotificationMessage({
            messageId,
            message: fallbackMessage,
            values,
          }),
        );
      }
    }

    return next(action);
  };
